import { OpenAPI } from '../api/core/OpenAPI';
import { ApiError } from '../api/core/ApiError';
import { request as __request } from '../api/core/request';

export type SessionUser = {
  id: number;
  email: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  groups: string[];
  isSslCertViewer: boolean;
  isEnvAnalyzerViewer: boolean;
  created: string;
  modified: string;
  last_login?: string | null;
};

export type SessionResponse = {
  authenticated: boolean;
  user: SessionUser | null;
  sso_enabled: boolean;
};

export async function fetchSession(): Promise<SessionResponse> {
  return __request(OpenAPI, {
    method: "GET",
    url: "/api/users/me/",
  });
}

export async function loginRequest(email: string, password: string): Promise<SessionResponse> {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/users/login/",
    body: { email, password },
    mediaType: "application/json",
  });
}

export async function logoutRequest() {
  return __request(OpenAPI, {
    method: "POST",
    url: "/api/users/logout/",
    mediaType: "application/json",
  });
}

export function startSsoLogin() {
  window.location.assign(`${OpenAPI.BASE}/api/users/sso/login/`);
}

export function getAuthErrorMessage(errorCode: string | null) {
  switch (errorCode) {
    case "user_not_provisioned":
      return "Your account is not enabled for this application.";
    case "saml_not_configured":
      return "Single sign-on is not configured for this environment yet.";
    case "saml_missing_email":
      return "Your identity provider did not send an email address.";
    case "saml_validation_failed":
    case "saml_not_authenticated":
      return "Single sign-on could not verify your identity. Please try again.";
    default:
      return "Authentication failed. Please try again.";
  }
}

export function getApiErrorMessage(error: unknown) {
  if (error instanceof ApiError) {
    if (error.status === 429) {
      return "Too many failed login attempts. Please try again later.";
    }
    const errorBody = error.body as { error?: string; detail?: string } | null;
    return errorBody?.error || errorBody?.detail || "Authentication failed. Please try again.";
  }
  return "An unexpected error occurred.";
}
